import { useEffect } from 'react';

/** Marks the tour's own UI (tip, spotlight, Sýnidæmi bar) so it is never made inert. */
export const SESSION_TUTORIAL_UI_ATTRIBUTE = 'data-session-tutorial-ui';

const isTourUi = (element: Element) =>
  element.hasAttribute(SESSION_TUTORIAL_UI_ATTRIBUTE) || !!element.querySelector(`[${SESSION_TUTORIAL_UI_ATTRIBUTE}]`);

/**
 * While `active`, everything on the page except `keep` (and the tour's UI) is inert: no clicks, no
 * keyboard focus, no typing. With `keep` null the whole page is. Nodes added later (e.g. a dropdown the
 * kept control opens) stay usable.
 */
export const useInertOutside = (keep: HTMLElement | null, active: boolean) => {
  useEffect(() => {
    if (!active) return;
    const madeInert: Element[] = [];
    const makeInert = (element: Element) => {
      if (element.hasAttribute('inert') || isTourUi(element)) return;
      element.setAttribute('inert', '');
      madeInert.push(element);
    };

    if (keep) {
      for (let node: Element = keep; node.parentElement && node !== document.body; node = node.parentElement) {
        for (const sibling of Array.from(node.parentElement.children)) {
          if (sibling !== node) makeInert(sibling);
        }
      }
    } else {
      for (const child of Array.from(document.body.children)) makeInert(child);
    }

    return () => {
      for (const element of madeInert) element.removeAttribute('inert');
    };
  }, [keep, active]);
};
